export default __webpack_public_path__ + "static/media/easytouse.88ab89fc.svg";